import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { StorageService } from '@morningstar/shared/base/storage-service';
import { select } from '@morningstar/shared/operators';
import { SyncfusionChartSettingsHelper } from '@morningstar/shared/util';
import { merge } from 'rxjs';
import { filter, startWith, tap } from 'rxjs/operators';
import { DashboardBaseComponent } from '../../dashboard-base/dashboard-base.component';
import { CheckInsSelectors } from '../check-ins.selectors';
import { CheckInsService } from '../check-ins.service';
import { MonthlyCheckIns } from './monthly-check-ins';

@Component({
  selector: 'wsg-monthly-check-ins',
  templateUrl: './monthly-check-ins.component.html',
  styleUrls: ['./monthly-check-ins.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MonthlyCheckInsComponent extends DashboardBaseComponent implements OnDestroy, AfterViewInit {
  
  // == CONSTANTS =======================================================

  title = 'Monthly Check-Ins';
  chartSettings = SyncfusionChartSettingsHelper.getBarChartSettings('percentage');

  // == STATE ===========================================================

  form = this.formBuilder.group({
    location: ''
  });

  state$ = this.checkInsService.state$;

  // == INTERMEDIATE ====================================================

  location$ = this.form.get('location').valueChanges.pipe(
    startWith('')
  );

  checkIns$ = this.state$.pipe(select<MonthlyCheckIns>(CheckInsSelectors.monthly))

  // == SIDE EFFECTS ====================================================

  onLocationChange$ = this.location$.pipe(
    filter(location => !!location),
    tap(location => this.checkInsService.getMonthlyCheckIns(location))
  );

  onGetCheckIns$ = this.checkIns$.pipe(
    tap(checkIns => {
      this.chart.dataSource = checkIns;
      this.chart.refresh();
    })
  );

  // == SUBSCRIPTION ====================================================

  subscription = merge(
    this.onGetCheckIns$,
    this.onLocationChange$
  ).subscribe();

  // == LIFECYCLE =======================================================

  constructor(private checkInsService: CheckInsService,
              private formBuilder: FormBuilder,
              protected storageService: StorageService) {
    super(storageService);
  };

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
